import * as types from '../actionsTypes/loadingTypes'

export const setIsLoading = value => ({
	type: types.IS_LOADING,
	payload: value
})
